import { UseFormReturn } from "react-hook-form";
import { FormField, FormItem, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { ConfiguracoesPJFormData } from "@/pages/configuracoes/schemas";

interface CompanyBankDetailsProps {
  form: UseFormReturn<ConfiguracoesPJFormData>;
}

export function CompanyBankDetails({ form }: CompanyBankDetailsProps) {
  return (
    <div className="flex flex-col gap-[24px]">
      {/* Disclaimer */}
      <p className="font-['Plus_Jakarta_Sans'] font-normal text-[16px] text-[#e7e7e7] leading-normal">
        Obs.: Os pagamentos serão feitos SOMENTE em conta jurídica, vinculada à empresa contratada. Não fazemos pagamentos em cheque.
      </p>

      {/* Row 1: Banco | Agência */}
      <div className="flex gap-[29px]">
        <FormField
          control={form.control}
          name="bancoPJ"
          render={({ field }) => (
            <FormItem className="flex-1">
              <label className="font-['Plus_Jakarta_Sans'] font-bold text-[16px] text-white leading-normal">
                Banco (PJ)
              </label>
              <FormControl>
                <Input placeholder="Digite aqui" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="agenciaPJ"
          render={({ field }) => (
            <FormItem className="flex-1">
              <label className="font-['Plus_Jakarta_Sans'] font-bold text-[16px] text-white leading-normal">
                Agência (PJ)
              </label>
              <FormControl>
                <Input placeholder="Digite aqui" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      {/* Row 2: Conta corrente | Chave Pix */}
      <div className="flex gap-[29px]">
        <FormField
          control={form.control}
          name="contaCorrentePJ"
          render={({ field }) => (
            <FormItem className="flex-1">
              <label className="font-['Plus_Jakarta_Sans'] font-bold text-[16px] text-white leading-normal">
                Conta corrente (PJ)
              </label>
              <FormControl>
                <Input placeholder="Digite aqui" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="chavePixPJ"
          render={({ field }) => (
            <FormItem className="flex-1">
              <label className="font-['Plus_Jakarta_Sans'] font-bold text-[16px] text-white leading-normal">
                Chave Pix (PJ)
              </label>
              <FormControl>
                <Input placeholder="Digite aqui" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}
